// src/components/Login.js
import React, { useState, useContext } from "react";
import axios from "axios";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { FloatLabel } from "primereact/floatlabel";
import { baseURL } from "../utils/api";
import "../css/Login.css";
import logo from "../assets/logo.jpg";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post(`${baseURL}api/auth/login`, { username, password })
      .then((response) => {
        const { user, token } = response.data;
        login(user, token);
        navigate("/");
      })
      .catch((error) => {
        console.error("Błąd logowania:", error);
        setError("Nieprawidłowa nazwa użytkownika lub hasło");
      });
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src={logo} alt="Janus App Logo"
            className="logoLogin" />
          </div>
          {/* <h1 className="login-title">Janus App</h1> */}
          {/* <p className="login-subtitle">Zaloguj się do systemu</p> */}
        </div>

        {error && (
          <div className="login-error">
            <i className="pi pi-exclamation-circle" />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleLogin} className="login-form">
          <div className="login-field">
            <FloatLabel>
              <InputText
                id="username"
                value={username}
                onChange={(e) => { setUsername(e.target.value); setError(null); }}
                required
                className="login-input-field"
              />
              <label htmlFor="username">Nazwa użytkownika</label>
            </FloatLabel>
          </div>
          <div className="login-field">
            <FloatLabel>
              <Password
                id="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(null); }}
                feedback={false}
                required
                toggleMask
                className="login-input-field"
              />
              <label htmlFor="password">Hasło</label>
            </FloatLabel>
          </div>
          <Button
            label="Zaloguj się"
            icon="pi pi-sign-in"
            type="submit"
            className="login-submit-btn"
            disabled={!username || !password}
          />
        </form>

        <div className="login-footer">
          <span>&copy; {new Date().getFullYear()} Janus App</span>
        </div>
      </div>
    </div>
  );
}

export default Login;
